import { Palette } from 'lucide-react';
import type { StudioMode } from '../types';

interface StudioHeaderProps {
  clientName: string;
  mode: StudioMode;
  agencyName?: string;
}

export function StudioHeader({ clientName, mode, agencyName }: StudioHeaderProps) {
  return (
    <header className="bg-neutral-900 text-white px-5 py-3 flex items-center justify-between">
      <div className="flex items-center gap-3">
        <Palette size={18} className="text-neutral-400" />
        <h1 className="text-base font-semibold m-0">{clientName}</h1>
        <span className="text-[11px] px-2 py-0.5 bg-white/10 rounded-full uppercase tracking-wider">
          {mode}
        </span>
      </div>
      {agencyName && (
        <span className="text-xs text-neutral-400">
          Powered by {agencyName}
        </span>
      )}
    </header>
  );
}
